import axios from 'axios'
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import FlatList from 'flatlist-react';
import { useNavigate } from 'react-router-dom';
import { documentos, meses, years } from '../../../helpers/datosVarios';
import { useGetTipoOtrosDoc } from '../../../hooks/useGetTipoOtrosDoc';
import Select from 'react-select'
import { UseGetEmpleadosSinDoc } from '../../../hooks/UseGetEmpleadosSinDoc';


export const DocFirmadosRep = () => {

  const dateObj = new Date();

    
  const empresa  = useSelector(state => state.app.empresa)

  const contraparte = JSON.parse(localStorage.getItem('dataUsuario'))

  let navigate = useNavigate();

  const vigentes  = useSelector(state => state.app.vigentes)


  const [firmados, setFirmados] = useState([])


  let portal = localStorage.getItem('sid')

  const {empleados} =  UseGetEmpleadosSinDoc()




  const consultarDatos = async () => {

    // console.log('ola')

      try {

          const response = await axios.get(`${process.env.REACT_APP_API_URL_BACK}api/firma/con-firmar-contraparte/${contraparte.perid}/${empresa.value}/${portal}`);
                  
          // console.log(response.data)

          // Filtramos para que la data del rut coincida con el rut de la empresa y que ademas le toque firmar

          let responseFiltradaEmpresa = response.data.filter(item  => item.empid === empresa.value   )
            
          setFirmados(responseFiltradaEmpresa.reverse())
          // console.log('responseFiltradaEmpresa',responseFiltradaEmpresa)

            // console.log(response,'response')

              // setLoading(false)


          } catch (error) {
            
          alert("Error de conexion","Intentalo otra vez", );
          // setLoading(false)
              console.log(error)
          }


  }

  useEffect(() => {

      if(empresa.value && contraparte.perid){
          consultarDatos()
  
      }
      
  }, [empresa])


  //--------------------------- FILTROS ------------------------------------


  
  const [arregloFiltro, setArregloFiltro] = useState([])


  
  const [porTrabajador, setPorTrabajador] = useState('')
  const [tipoDoc, setTipoDoc] = useState('')




  const {finUniqTiposOtrosodoc} = useGetTipoOtrosDoc(firmados)
  //  A los ya existentes tipos de doc, le sumamos los tipos creados por el usuario
  const newDocumentos = [...documentos,...finUniqTiposOtrosodoc]


  
  // elementos para filtrar por fecha de firma


  const mesActual = `${dateObj.getMonth()+1}`.length === 1 ? `0${dateObj.getMonth()+1}` : dateObj.getMonth()+1
  const mesActualDesdeData = meses.find( item => item.value == mesActual )

  
  const [mes, setMes] = useState(mesActualDesdeData )
  const [year, setYear] = useState(years[0])

  const filtro = useMemo(() => firmados.filter(item => item.idContraparte == contraparte.perid ? item.fechaContraparte.split('/')[2] === `${year.label}` : item.fechaContraparte2.split('/')[2] === `${year.label}` ) , [year,firmados]) 
  
 
  // Con esto solucionamos el problema de cuando la contraparte aveces es la primera o aveces las segunda cuando son 3 firmas

  const finalizadasYearActual = filtro.map((obj) => {
    if (obj.idContraparte2 === contraparte.perid) {
      // Si idContraparte2 es igual a contraparte.perid, eliminamos las propiedades terminadas en 2
      obj.idContraparte = obj.idContraparte2
      obj.emailContraparte = obj.emailContraparte2
      obj.nombreContraparte = obj.nombreContraparte2
      obj.firmaContraparte = obj.firmaContraparte2
      obj.firmaContraparte = obj.firmaContraparte2
      obj.fechaContraparte = obj.fechaContraparte2
      obj.ipContraparte = obj.ipContraparte2
      obj.soContraparte = obj.soContraparte2

      delete obj.idContraparte2
      delete obj.emailContraparte2
      delete obj.nombreContraparte2
      delete obj.firmaContraparte2
      delete obj.fechaContraparte2
      delete obj.ipContraparte2
      delete obj.soContraparte2
 
    }

    return obj

    // Si idContraparte2 no es igual a contraparte.perid, no hacemos cambios en el objeto
    
  });
  


  const restablecerFiltros = () => {

      setTipoDoc('')
      setPorTrabajador('')
      setMes('')
      setYear(years[0])
    }
  



    
    useEffect(() => {

      if(porTrabajador === '' && tipoDoc.value == undefined && mes !== '' ){

                  const filtro = finalizadasYearActual.filter(item => item.fechaContraparte.split('/')[1] == mes?.value)

                  // console.log(filtro,'filtrooooo')
                  setArregloFiltro(filtro)
                  return
      }

      if(porTrabajador !== '' && tipoDoc.value == undefined && mes === '' ){

        const filtro = finalizadasYearActual.filter(item => item.nombreTrabajador === porTrabajador.nombreCompleto)

        // console.log(filtro,'qepasa')
        // console.log(tipoDoc.value,'tipodoc')
    
          setArregloFiltro(filtro)
          return
        
      }

      if(porTrabajador  !== '' && tipoDoc.value == undefined && mes !== '' ){

        const filtro = finalizadasYearActual.filter(item => item.nombreTrabajador === porTrabajador.nombreCompleto && item.fechaContraparte.split('/')[1] == mes?.value)

        // console.log(filtro,'qepasa')
        // console.log(tipoDoc.value,'tipodoc')
    
          setArregloFiltro(filtro)
          return
        
      }

      if(tipoDoc.value === 'Otros Documentos' && mes ===''  ){

    
        const filtro = finalizadasYearActual.filter(item =>  item.tipo !== 'Contrato' && item.tipo !== 'Anexo' && item.tipo !== 'Liquidación')
        setArregloFiltro(filtro)
   

   


    }
      if(tipoDoc.value === 'Otros Documentos' && mes !== '' ){

    
        const filtro = finalizadasYearActual.filter(item =>  item.tipo !== 'Contrato' && item.tipo !== 'Anexo' && item.tipo !== 'Liquidación' && item.fechaContraparte.split('/')[1] == mes?.value)
        setArregloFiltro(filtro)
   

   


    }
    if(tipoDoc.value !== 'Otros Documentos' && tipoDoc.value !== undefined && mes === '' ){

   
      const filtro = finalizadasYearActual.filter(item => item.tipo === tipoDoc.value)
      // console.log(filtro,'qepasa')

    
      setArregloFiltro(filtro)


    }
    if(tipoDoc.value !== 'Otros Documentos' && tipoDoc.value !== undefined && mes !== '' ){

   
      const filtro = finalizadasYearActual.filter(item => item.tipo === tipoDoc.value && item.fechaContraparte.split('/')[1] == mes?.value)
      // console.log(filtro,'qepasa')

    
      setArregloFiltro(filtro)


    }

    
      if(porTrabajador !== '' && tipoDoc.value !== 'Otros Documentos' && mes === '' ){

  


        const filtro = finalizadasYearActual.filter(item => item.nombreTrabajador === porTrabajador.nombreCompleto && item.tipo === tipoDoc.value)
     
        setArregloFiltro(filtro)


      }
      if(porTrabajador !== '' && tipoDoc.value !== 'Otros Documentos' && mes !== '' ){

  


        const filtro = finalizadasYearActual.filter(item => item.nombreTrabajador === porTrabajador.nombreCompleto && item.tipo === tipoDoc.value && item.fechaContraparte.split('/')[1] == mes?.value)
     
        setArregloFiltro(filtro)


      }
      if(porTrabajador !== '' && tipoDoc.value === 'Otros Documentos' && mes === '' ){

        const filtro = finalizadasYearActual.filter(item => item.nombreTrabajador === porTrabajador.nombreCompleto && item.tipo !== 'Contrato' && item.tipo !== 'Anexo' && item.tipo !== 'Liquidación')
        setArregloFiltro(filtro)
     
    }
      if(porTrabajador !== '' && tipoDoc.value === 'Otros Documentos'  && mes !== '' ){

        const filtro = finalizadasYearActual.filter(item => item.nombreTrabajador === porTrabajador.nombreCompleto && item.tipo !== 'Contrato' && item.tipo !== 'Anexo' && item.tipo !== 'Liquidación' && item.fechaContraparte.split('/')[1] == mes?.value)
        setArregloFiltro(filtro)
     
    }

    // console.log(arregloFiltro,'arregloFiltro')

    }, [tipoDoc, porTrabajador, mes,year,firmados,vigentes])


    useEffect(() => {
      setTipoDoc('')
      setPorTrabajador('')
      setYear(years[0])
      setMes(mesActualDesdeData)
    }, [vigentes])


  return (
    
    <div className='contenidoTodoTablaDocPorFirmarRep' > 


                    <div className='filtros'>


                                <p className='tipoFiltro ' >Trabajador</p>
                                <Select className='filtrosFinalizadas' options={empleados} value={porTrabajador} onChange={setPorTrabajador}  />

                                <p className='tipoFiltro' >Tipo de documento</p>
                                <Select className='filtrosFinalizadas' options={newDocumentos} value={tipoDoc} onChange={setTipoDoc}  />

                                <p className='tipoFiltro' >Mes de firma</p>
                                <Select className='year' options={meses} value={mes} onChange={setMes}  /> 

                                <p className='tipoFiltro' >Año de firma</p>
                                <Select className='year' options={years} value={year} onChange={setYear}  />


                              
                    </div>

                    <div className='restablecerFiltros' >
                                    <p  className='' onClick={restablecerFiltros} > Restablecer filtros</p>

                                </div>


    {/* header tabla */}

                <div className='headerTablaDocFirmados' >

                        <p>Fecha firma</p>
                        <p>Tipo de documento</p>
                        <p>Trabajador(a)</p>
                        <p>Accion</p>
                        


                </div>
                

                <div className='contenidoTablaDocFirmados' >



                    
                <FlatList list={tipoDoc || porTrabajador || mes  ? arregloFiltro : finalizadasYearActual} renderItem={(item,index) => 
                    <div key={index} className='divflatdocfirmados' >
                        <p className='bold' >{ item.idContraparte == contraparte.perid ? item.fechaContraparte : item.fechaContraparte2 }</p>
                        <p>{item.tipo}</p>
                        <p className='bold' >{item.nombreTrabajador}</p>
                        <p className='firmar' onClick={ () => navigate(`/firmar-pdf-representantes/${item.id}`,{ state: {rut:contraparte.value, nombre: contraparte.label, email: contraparte.email} } )} > Ver  </p>
                        

                    
                        


                    </div>
            
            
            
            
                
                }
                
                renderWhenEmpty={() =>
                    <div className='renderEmpty' >

                    
                     {!contraparte.perid ? <p className='renderVacio'> Representante no tiene ingresado un rut </p> : <p className='renderVacio'> No has firmado documentos que cumplan con los filtros </p>  }
                    

                

                    </div>
                }
                hasMoreItems
                renderOnScroll
                />

                

                    



                </div>


    



</div>
  )
}
